"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMergeStatus = void 0;
let EMergeStatus = exports.EMergeStatus = /*#__PURE__*/function (EMergeStatus) {
  EMergeStatus["Initial"] = "initial";
  EMergeStatus["Loading"] = "loading";
  EMergeStatus["Succeed"] = "succeed";
  EMergeStatus["Failed"] = "failed";
  return EMergeStatus;
}({});